module.exports = __webpack_public_path__ + "728ac082226970fb6f2864f1cb5a980b.png";